var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlankHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7578 2.91113C24.5968 2.91113 21.8258 4.32062 19.7443 6.9873C19.4668 7.34296 19.2193 7.69876 19 8.04336C18.7807 7.69869 18.5332 7.34296 18.2557 6.9873C16.1742 4.32062 13.4032 2.91113 10.2422 2.91113C4.27084 2.91113 0 7.91103 0 13.9106C0 20.7709 5.62259 27.2364 18.2309 34.8745C18.4673 35.0176 18.7336 35.0893 19 35.0893C19.2664 35.0893 19.5327 35.0177 19.7691 34.8745C32.3774 27.2365 38 20.771 38 13.9107C38 7.91422 33.7326 2.91113 27.7578 2.91113ZM31.1093 22.4529C28.4844 25.3817 24.5178 28.4656 19 31.8655C13.4822 28.4656 9.51559 25.3817 6.89069 22.4529C4.25162 19.5082 2.96875 16.714 2.96875 13.9107C2.96875 9.59089 5.88807 5.87988 10.2422 5.87988C12.4595 5.87988 14.3502 6.84398 15.8617 8.74547C17.0702 10.2661 17.5795 11.8364 17.583 11.8476C17.7764 12.4677 18.3505 12.8901 19.0001 12.8901C19.6496 12.8901 20.2238 12.4678 20.4171 11.8476C20.4218 11.8326 20.9157 10.3113 22.0846 8.8139C23.6042 6.86699 25.513 5.87981 27.7578 5.87981C32.1165 5.87981 35.0312 9.59438 35.0312 13.9106C35.0312 16.714 33.7484 19.5082 31.1093 22.4529Z",
    fill: "#3C4043"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankHeart);
export default __webpack_public_path__ + "static/media/blank-heart.cd94654160e9b6e7c4326176cad18c9b.svg";
export { ForwardRef as ReactComponent };